function searchableText(value) {
  return String(value || "").normalize("NFKD").replace(/\p{M}/gu, "").toLocaleLowerCase().trim()
}

export function workspaceSearchItems({ concepts = [], personas = [], actions = [], issues = [], conceptPath = "", contextPath = "" } = {}) {
  const entries = []
  const add = (type, item, title, description, href) => {
    const key = item.key || item.id
    if (!key || !title || !href) return

    entries.push({
      id: `${type}:${key}`,
      type,
      item,
      title,
      description: String(description || ""),
      href,
      titleText: searchableText(title),
      searchText: searchableText([title, description, key, `${type}s`, ...(item.formerTitles || [])].join(" "))
    })
  }

  concepts.forEach((item) => add("concept", item, item.title || item.name, item.summary, item.detailPath))
  personas.forEach((item) => add("persona", item, item.name, [item.role, item.description, item.narrative, ...(item.goals || [])].filter(Boolean).join(" "), conceptPath && `${conceptPath}/personas/${encodeURIComponent(item.key)}`))
  actions.forEach((item) => add("action", item, item.label || item.title || item.name, [item.description, item.summary, item.userIntent, item.outcome].filter(Boolean).join(" "), conceptPath && `${conceptPath}/actions/${encodeURIComponent(item.key)}`))
  issues.forEach((item) => add("issue", item, item.title, [item.summary, item.description, item.body, item.status].filter(Boolean).join(" "), item.detailPath))
  add("context", { key: "context" }, "context.md", "Repository context", contextPath)
  return entries
}

export function searchWorkspaceItems(items, query) {
  const text = searchableText(query)
  if (!text) return []

  const terms = text.split(/\s+/)
  const score = (item) => item.titleText === text ? 3 : item.titleText.startsWith(text) ? 2 : item.titleText.includes(text) ? 1 : 0
  return items
    .filter((item) => terms.every((term) => item.searchText.includes(term)))
    .sort((left, right) => score(right) - score(left) || left.title.localeCompare(right.title))
}
